module.exports = __webpack_public_path__ + "static/img_nh.754a1f0e.png";